<!-- 记录详情 -->
<template>
    <div class="record-detail">
        <div class="record-detail-fee-up">
            <div class="container flex flex-column justify-center align-center">
                <div>
                    <span class="texts">￥</span>
                    <span class="text">{{ recordItem.consume }}</span>
                </div>
                <div class="text-bottom">- 停车费用 -</div>
            </div>
            <div class="image" :class="payStatus == 1 ? 'unpaid' : recordItem.payStatus == 2 ? 'fee-free' : recordItem.payStatus == 3 ? 'paid' : ''"></div>
        </div>
        <div class="record-detail-fee-down">
            <div class="item">
                <div>车牌号</div>
                <div>{{ parseCarCode(recordItem.plateNum) }}</div>
            </div>
            <div class="item">
                <div>驶入时间</div>
                <div>{{ recordItem.inTime }}</div>
            </div>
            <div class="item">
                <div>驶出时间</div>
                <div>{{ recordItem.outTime }}</div>
            </div>
            <div class="item">
                <div>停车时长</div>
                <div>{{ secondToMinute(recordItem.parkingTime) }}分钟</div>
            </div>
            <div class="item">
                <div>停车位置</div>
                <div>{{ recordItem.parkName }}</div>
            </div>

            <div v-if="recordItem.type == 1" class="item">
                <div>泊位编号</div>
                <div>{{ recordItem.stallCode }}</div>
            </div>

            <div v-if="recordItem.payInfo.length > 0">
                <div class="bold-title">费用明细</div>
                <div class="fee" v-for="item in recordItem.payInfo" :key="item.orderCode">
                    <div class="inner-item">{{ item.payTime }}</div>
                    <div class="inner-item">
                        <div>{{ item.payChannelDesc }}</div>
                        <div>{{ item.realMoney }}</div>
                    </div>

                    <div class="inner-item">
                        <div>优惠券</div>
                        <div>-¥{{ item.couponTicketMoney || "0.00" }}</div>
                    </div>
                    <div class="inner-item">
                        <div class="detailLabel">随机立减</div>
                        <div>-¥{{ item.couponRandomMoney || "0.00" }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="record-detail-fee-down-side"></div>

        <div class="record-detail-bottom flex align-center justify-between">
            <div class="flex align-center">
                <img src="@/assets/images/pay/question.png" />
                <div class="text">对订单有疑问？</div>
            </div>
            <van-button @click="skipAppeal" class="button">去申诉</van-button>
        </div>
    </div>
</template>

<script>
import { parseCarCode, secondToMinute } from "@/libs/tools";
import { queryMyParkingRecordDetail } from "@/api/api";
export default {
    name: "RecordDetail",
    components: {},
    data() {
        return {
            recordItem: {
                plateNum: "",
                payInfo: [],
            }, //停车记录
            payStatus: -1, //类型
        };
    },

    mounted() {
        // this.recordItem = this.$route.params;

        let obj = this.$route.params;
        this.payStatus = obj.payStatus;
        // this.recordItem = {
        //     arrearsType: 1,
        //     consume: 0.01,
        //     couponDetailId: null,
        //     couponMoney: 0,
        //     couponRandomId: null,
        //     couponRandomMoney: 0,
        //     couponRandomName: null,
        //     couponTicketMoney: 0,
        //     display: 1,
        //     inTime: "2021-11-26 16:48:44",
        //     lat: "25.330447",
        //     lng: "118.303323",
        //     orderMoney: 0.01,
        //     outTime: "2021-11-26 20:48:44",
        //     parkCode: "CS001",
        //     parkName: "路内演示停车场",
        //     parkNameReal: "路内演示停车场",
        //     parkType: 1,
        //     parkingRecordId: "a46c2ff1f31340fab807c114c4ee121a",
        //     parkingTime: "14400",
        //     payForMoney: 0,
        //     payInfo: [
        //         {
        //             payChannel: 1,
        //             payChannelDesc: "平台支付",
        //             realMoney: "0.00",
        //             couponTicketMoney: 0,
        //             couponRandomMoney: 0.09,
        //             payForMoney: 0.01,
        //             payTime: "*******-28 15:01:13",
        //             orderCode: "2021111802323232",
        //         },
        //         {
        //             payChannel: 1,
        //             payChannelDesc: "平台支付",
        //             realMoney: "0.00",
        //             couponTicketMoney: 0,
        //             couponRandomMoney: 0.09,
        //             payForMoney: 0.01,
        //             payTime: "*******-28 15:01:13",
        //             orderCode: "2021111802323232",
        //         },
        //     ],
        //     plateNum: "闽E44444",
        //     realMoney: 0.01,
        //     realPay: 0,
        //     stallCode: "DING01",
        //     status: 2,
        //     waitingOutTime: null,
        // };
        queryMyParkingRecordDetail(obj).then((res) => {
            this.recordItem = res.data;
        });
    },

    methods: {
        parseCarCode,
        secondToMinute,
        //跳转到申诉
        skipAppeal() {
            this.$router.replace({ name: "Suggestion", params: {} });
        },
    },
};
</script>
<style lang="less" scoped>
.record-detail {
    padding: 16px 24px;
    .record-detail-fee-up {
        height: 208px;
        position: relative;
        width: 702px;
        background: url("~@/assets/images/pay/up-card.png") no-repeat;
        background-size: 100% 100%;
        .container {
            width: 702px;
            height: 170px;
            .text {
                font-family: DIN Alternate;
                font-size: 60px;
                font-weight: bold;
                color: #ff8b19;
            }
            .texts {
                color: #ff8b19;
                font-weight: bold;
            }
            .text-bottom {
                margin-top: 15px;
                color: #666;
                font-family: "PingFangSC";
                font-size: 24px;
            }
        }

        .image {
            height: 146px;
            width: 152px;
            position: absolute;
            left: 0;
            top: 0;
        }
        .fee-free {
            background: url(../../assets/images/pay/fee-frees.png) no-repeat;
            background-size: 100% 100%;
        }
        .unpaid {
            background: url(../../assets/images/pay/unpaids.png) no-repeat;
            background-size: 100% 100%;
        }
        .paid {
            background: url(../../assets/images/pay/paids.png) no-repeat;
            background-size: 100% 100%;
        }
    }

    .record-detail-fee-down {
        min-height: 340px;
        width: 702px;
        background: url("~@/assets/images/pay/down-card.png") no-repeat;
        background-size: 100% 100%;
        padding: 15px 33px;
        font-size: 30px;
        color: #666;
        .item {
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .inner-item {
            margin-bottom: 10px;
            font-size: 28px;
            display: flex;
            justify-content: space-between;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .fee {
            background-color: #f2f6f5;
            border-radius: 10px;
            padding: 15px 33px;
        }

        .bold-title {
            font-weight: bold;
            margin-bottom: 20px;
        }
    }
    .record-detail-fee-down-side {
        min-height: 32px;
        width: 702px;
        background: url("~@/assets/images/pay/down-cards.png") no-repeat;
        background-size: 100% 100%;
    }
    .record-detail-bottom {
        margin-top: 32px;
        padding: 12px 24px;
        width: 100%;
        height: 72px;
        border-radius: 10px;
        background-color: #fff;
        img {
            width: 32px;
            height: 32px;
        }
        .text {
            margin-left: 17px;
            font-size: 28px;
            color: #009af3;
            font-family: "PingFangSC";
        }
        .button {
            height: 48px;
            width: 128px;
            font-size: 28px;
            white-space: nowrap;
            color: #fff;
            border-radius: 10px;
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
        }
    }
}
</style>
